// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-1-m__wrapper__3Cn-0"};